import {
  compareSnapshot,
  createBackup,
  exportSnapshot,
  listSnapshots,
  restoreSnapshot,
} from "@/services/api/app/salesforce/recovery/salesforceObject/object";
import {
  connectAws,
  connectAzure,
  connectDropbox,
  deleteConnection,
  listConnection,
  listRegion,
  connectGoogle,
  connectMicrosoft,
  connectBox,
  editAzure,
  editAws,
  editGoogleCloud,
  editS3Compatible,
  connectS3Compatible,
  connectGoogleCloud,
  listRegionsGCP
} from "@/services/api/common/connection";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  userMap: {},
  listRegions: {},
  listRegionsGcp: {},
  connectionDetails: {},
  connections: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'DisplayName',
  },
});

export default {
  namespaced: true,
  actions: {
    createBackup({commit}) {
      return createBackup();
    },
    listSnapshots({commit}, {date, dateTo}) {
      return listSnapshots({date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot(data);
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({ commit, state }, data) {
      return listConnection({
        ...data,
        providerTenantType: 4,
        pagination: state.pagination
      })
        .then(({ result, pagination }) => {
          commit('setConnections', result);
          commit('setPagination', pagination);
        })
        .catch(error => {
          console.error("Failed to list connections:", error);
          throw error;
        });
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
    compareSnapshot({}, data) {
      return compareSnapshot(data);
    },
    editAwsConnection({ dispatch, state }, { id, bucketName, accessKey, secretKey, region }) {
      return editAws({ id, bucketName, accessKey, secretKey, region })
          .then(() => {
            return dispatch('listConnection', { pagination: state.pagination })
          })
    },
    editAzureConnection({ dispatch, state }, { id, containerName, accountName, accountKey }) {
      return editAzure({ id, containerName, accountName, accountKey })
          .then(() => {
            return dispatch('listConnection', { pagination: state.pagination })
          })
    },
    editS3CompatibleConnection({ dispatch, state }, { id, accessKey, bucketName, region, secretKey, endpointUrl }) {
      return editS3Compatible({ id, accessKey, bucketName, region, secretKey, endpointUrl })
        .then(() => {
          return dispatch('listConnection', { pagination: state.pagination })
        })
    },
    editGoogleCloudConnection({ dispatch, state }, { id, accessKey, bucketName, region, secretKey }) {
      return editGoogleCloud({ id, bucketName, accessKey, region, secretKey })
        .then(() => {
          return dispatch('listConnection', { pagination: state.pagination })
        })
    }
  },

  mutations: {
    setUser(state, user) {
      state.userMap = {
        ...state.userMap,
        [user.userId]: user
      };
    },
    setConnectionDetails(state, connectionDetails) {
      state.connectionDetails = connectionDetails;
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setConnections(state, connections) {
      state.connections = connections;
    },
  },

  getters: {
    getUserById: (state) => (id) => {
      return state.userMap[id];
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getAllConnections(state) {
      return state.connections.map(connection => ({
        ...connection,
      }));
    },
    isStorageDestination: () => (connection) => {
      if (!connection) return false;

      const storageProviders = ['AWS', 'AzureBlob', 'S3Compatible', 'GoogleCloud'];
      const storageTypes = [1, 2, 7, 8];

      if (storageProviders.includes(connection.provider)) {
        return true;
      }

      return storageTypes.includes(connection.storageDestinationType);
    }
  },

  state: defaultState,

  // modules: {
  //   files,
  //   exports,
  //   restores,
  //   backups,
  //   compares,
  //   seeding
  // }
}
